import * as _ from 'lodash';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { selectAuctionCampaignList} from 'app/campaign/features/campaign.selectors';
import { loadManageCampaignList,  } from 'app/campaign/features/campaign.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { UntypedFormControl } from '@angular/forms';
import { selectOrgUser } from 'app/dashboard/features/dashboard.selectors';
import { loadOrgUser } from 'app/dashboard/features/dashboard.actions';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-auctions-list',
  templateUrl: './auctions-list.component.html',
  styleUrls: ['./auctions-list.component.scss']
})
export class AuctionsListComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public auctions$: any = this.store.pipe(
    select(selectAuctionCampaignList),
    takeUntilDestroyed()
  );

  public auctions = []
  public filteredAuctions = []
  public userHandle = ''
  public isShowFilteredAuctions = false



  public totalAuctions = 0;
  public activeAuctions = 0;
  public pausedAuctions = 0;
  public endedAuctions = 0;
  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    first(user => !_.isNull(user)),
   takeUntilDestroyed()
  );


  public search: UntypedFormControl = new UntypedFormControl('', []);



  constructor(
    public store: Store,
    public sharedService: SharedService,
    public auctionManageService:AuctionManageService
  ) { }

  ngOnInit(): void {
    this.store.dispatch({
      type:loadOrgUser.type,
    })

    this.orgUser$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((user:any)=>{
      if(user){
        this.userHandle = user.handle
        this.store.dispatch({
          type: loadManageCampaignList.type,
          payload:this.sharedService.token,
          statusFilter:0,
          campaignTypes:[CAMPAIGN_TYPE.AUCTION]
        });
      }
    }) 

    this.auctions$.subscribe((auctions)=>{
      this.auctions = [...auctions]
      this.filteredAuctions = [...auctions]
      if(auctions.length !== 0){
        this.isShowFilteredAuctions = true;
      }
      this.filterAuctionByStatus(auctions);
    });

        this.search.valueChanges.pipe(
          takeUntilDestroyed(this.destroyRef)
        ).subscribe(search => {
          this.filteredAuctions = _.filter(this.auctions, (auction: any) => {
            if(this.auctions.length !== 0){
              return _.includes(auction.name.toLowerCase(), search.toLowerCase())
            }   
          });
          if(this.filteredAuctions.length !== 0){
            this.isShowFilteredAuctions = true;
          }else{
            this.isShowFilteredAuctions = false;
          }
        }); 

  }

  resetSearch() {
    this.search.setValue('');
  }

  getFilteredCampaignList(campaigns, status) {
    const list = _.isNull(status) ? campaigns: _.filter(campaigns, campaign => {
      if(_.isArray(status)) {
        return _.indexOf(status, campaign.status) < 0 ? false: true;
      }
      return _.isEqual(campaign.status, status);
    }) || [];
    return _.sortBy(list, [function(campaign) { return -campaign.updated; }]);
  }

  filterAuctionByStatus(auctions){
    let totalAuctions  = [...this.getFilteredCampaignList(auctions, [0,1,2,3])]
    this.totalAuctions = totalAuctions.length
    this.activeAuctions = totalAuctions.filter(auction=>{return this.auctionManageService.getAuctionStatus(auction).status == this.auctionManageService.AuctionStatusBiddingOpen}).length
    this.pausedAuctions = totalAuctions.filter(auction=>{return this.auctionManageService.getAuctionStatus(auction).status == this.auctionManageService.AuctionStatusBiddingPaused}).length
    this.endedAuctions = totalAuctions.filter(auction=>{return this.auctionManageService.getAuctionStatus(auction).status == this.auctionManageService.AuctionStatusFinalized}).length
  }



  ngOnDestroy(){
    this.auctionManageService.totalAuctions = 0;
    this.auctionManageService.activeAuctions = 0;
    this.auctionManageService.pausedAuctions = 0;
    this.auctionManageService.endedAuctions = 0;
  }
}
